import { useDispatch } from "react-redux";
import { fetchUserOrders } from "ducks/actions";
import { useEffect, useState } from "react";
const useFetchOrder = isLoggedIn => {
  const [order, setdata] = useState([]);
  const [loading, setLoading] = useState(isLoggedIn ? true : false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(
        fetchUserOrders({}, (userOrders, errors) => {
          setdata(userOrders);
          setLoading(false);
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { order, loading };
};
export default useFetchOrder;
